export default __webpack_public_path__ + "0171ea40334f61e9221ac2318ed083bd.png";